import {useEffect, useState} from 'react';
import './UserAvatar.less';

const AVATAR_COLORS = [
    '#5B7FA5', '#7A6B8E', '#6B8E6B', '#8E7A5B',
    '#5B8E8E', '#8E5B6B', '#6B7A8E', '#8E8E5B',
];

function hashString(str: string): number {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = ((hash << 5) - hash) + str.charCodeAt(i);
        hash |= 0;
    }
    return Math.abs(hash);
}

export type UserAvatarProps = {
    initials: string;
    picture?: string | null;
    size?: number;
    onClick?: (e: React.MouseEvent) => void;
    className?: string;
};

export default function UserAvatar({initials, picture, size = 32, onClick, className}: UserAvatarProps) {
    const [imgError, setImgError] = useState(false);
    useEffect(() => setImgError(false), [picture]);

    const bgColor = AVATAR_COLORS[hashString(initials || '') % AVATAR_COLORS.length];

    const style: React.CSSProperties = {
        width: size,
        height: size,
        fontSize: size * 0.4,
        lineHeight: `${size}px`,
    };

    const classes = ['user-avatar', className].filter(Boolean).join(' ');

    // The picture sits over the initials: a transparent Gravatar answer (no picture for that
    // address) or a failed load leaves the initials showing.
    return (
        <div
            className={classes}
            style={{...style, backgroundColor: bgColor}}
            onClick={onClick}
            role="button"
            tabIndex={0}
        >
            {initials}
            {picture && !imgError && (
                <img
                    src={picture}
                    alt=""
                    className="user-avatar__img"
                    onError={() => setImgError(true)}
                />
            )}
        </div>
    );
}
